import ApiBase from './ApiBase';
import LogApi from './LogApi';
import { getIcError } from '../../core/providers/utils';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

class UserMailApi extends ApiBase {
  async create(emailData, userId) {
    const trackingId = uuidv4();

    LogApi.sendClientlogs(
      LogApi.createTrackingObject(
        trackingId,
        null,
        `user id: ${userId}`,
        null,
        null,
        `POST v1/mail/sendmail`,
        `Contact Screen Send Email API call`
      )
    ).catch(err => {
      console.error('Server error: ' + getIcError(err));
    });

    const headers = this.getHeaders();
    headers['TRACKING-REQUEST-ID'] = trackingId;

    const request = {
      url: `${this.API_URL}/mail/sendmail`,
      method: 'POST',
      headers: headers,
      data: emailData
    };

    const response = await axios.request(request);
    return response.data;
  }
}
export default new UserMailApi();
